import { createStyles, makeStyles } from "@material-ui/core/styles";

export { useAboutStyles };

const useAboutStyles = makeStyles(() =>
	createStyles({
		appbar: {
			display: "flex",
			flexDirection: "row",
			alignItems: "center",
			marginBottom: "8px",
			padding: "8px 24px 8px 24px",
			zIndex: -1,
		},
		title: {
			fontSize: "0.875rem",
		},
		copyright: {
			padding: "8px 24px 8px 24px",
		},
		aboutContainer: {
			height: "100vh",
			display: "flex",
			flexDirection: "column",
		},
		tableHeader: {
			fontWeight: "bold",
			backgroundColor: "white",
		},
		paperContainer: {
			overflow: "auto",
			margin: "0 24px 32px 24px",
			height: "100%",
		},
		text: {
			paddingTop: 10,
		},
	})
);
